import { Boletagem } from "../boletagem";
import { BoletagemFlex } from "../boletagem-flex";
import { BoletagemPgtoDiferenciado } from "../boletagem-pgto-diferenciado";
import { BoletagemProdutoAnexo } from "../boletagem-produto-anexo";
import { GrandezaEnergia } from "../boletagem/model";
import { Usuario } from "../usuario";

export enum BoletagemProdutoFaturamento {
  Sim = "S",
  Não = "N",
}

export enum BoletagemProdutoPagamento {
  Sim = "S",
  Não = "N",
}

export enum BoletagemProdutoRegistro {
  Sim = "S",
  Não = "N",
}

export enum BoletagemProdutoLiberarRegistro {
  Sim = "S",
  Não = "N",
}

export enum BoletagemProdutoLiberarFaturamento {
  Sim = "S",
  Não = "N",
}

export enum BoletagemProdutoHabilitadoNetFinanceiro {
  Sim = "S",
  Não = "N",
}

export interface BoletagemProduto {
  readonly id?: number | null;
  readonly boletagem?: Boletagem | null;
  readonly anoMes?: string | null;
  readonly volumeEnergiaMedio?: number | null;
  readonly volumeEnergiaHora?: number | null;
  readonly flex?: string | null;
  readonly flexibilidades?: BoletagemFlex[] | null;
  readonly pgtoDiferenciado?: boolean | null;
  readonly pgtosDiferenciados?: BoletagemPgtoDiferenciado[] | null;
  readonly faturamento?: BoletagemProdutoFaturamento | null;
  readonly pagamento?: BoletagemProdutoPagamento | null;
  readonly registro?: BoletagemProdutoRegistro | null;
  readonly liberarRegistro?: BoletagemProdutoLiberarRegistro | null;
  readonly liberarFaturamento?: BoletagemProdutoLiberarFaturamento | null;
  readonly preco?: number | null;
  readonly NF?: string | null;
  readonly vencimentoNF?: string | null;
  readonly multa?: number | null;
  readonly grandeza?: GrandezaEnergia | null;
  readonly volumeTotal?: number | null;
  readonly valorTotal?: number | null;
  readonly anexos?: BoletagemProdutoAnexo[] | null;
  readonly habilitadoNetFinanceiro?: BoletagemProdutoHabilitadoNetFinanceiro | null;
  readonly usuarioHabilitadoNetFinanceiro?: Usuario | null;
  readonly dataHabilitadoNetFinanceiro?: string | null;
}
